import { render } from "./ContractsTableComponent.vue?vue&type=template&id=0342befa&scoped=true"
import script from "./ContractsTableComponent.vue?vue&type=script&lang=js"
export * from "./ContractsTableComponent.vue?vue&type=script&lang=js"

import "./ContractsTableComponent.vue?vue&type=style&index=0&id=0342befa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0342befa"]])

export default __exports__